export const borderWidths = {
    sm: '1px',
    md: '2px',
    lg: '4px',
};
//# sourceMappingURL=border-widths.js.map